import { TableDataChartComponent } from '../charts/table-data-chart-component'

export class AFTopTwitterAuthors extends TableDataChartComponent {
 static config = {
  selector: 'afTopTwitterAuthors',
  controller: AFTopTwitterAuthors,
  bindings: TableDataChartComponent.config.bindings,
  template: TableDataChartComponent.config.template + `
    <div ng-if="(!$ctrl.isLoading) && $ctrl.isRestricted" class="top__twitter">
        <mw-empty-state>
            <mw-empty-state-sub-text>
                This content is anonymized to comply with Twitter‘s terms of service.
            </mw-empty-state-sub-text>
        </mw-empty-state>
    </div>
  `,
 }

  buildTableDataChartData(data) {
    // calculate indexes for pagination
    let startIndex = this.pagination.currentPage * this.pagination.pageSize
    let endIndex = this.pagination.currentPage * this.pagination.pageSize + this.pagination.pageSize
    return data.slice(startIndex, endIndex).map(x => ({
      ...x, key: '@' + x.key,
    }))
  }
}
